import { uniq } from 'lodash';

import fcRapidaRules from './rules/fcRapidaRules';

const incomeFieldsPF = ({origem_renda, origem_renda_secundaria, renda_principal, outras_rendas}) => [
  origem_renda === "1" || !origem_renda ? 'renda_principal' : 'renda_principal_obrigatoria',
  renda_principal === '' || !renda_principal ? 'origem_renda' : 'origem_renda_obrigatoria',
  origem_renda_secundaria === "1" || !origem_renda_secundaria ? 'outras_rendas' : 'outras_rendas_obrigatoria',
  outras_rendas === '' || !outras_rendas ? 'origem_renda_secundaria' : 'origem_renda_secundaria_obrigatoria',
  'total_renda'
  // 'compor_renda'
];

const incomeFieldsPJ = [
  // 'faturamento_mensal',
  // 'tipo_negocio',
  // 'natureza_juridica'
  'receita_media_mensal',
  'capital_de_investimento',
  'patrimonio_estimado'
];

const productsPF = [
  {
    id: 1,
    name: 'FCRAPIDA',
    fields: [
      'renda_principal',
      'renda_principal_obrigatoria',
      'origem_renda',
      'origem_renda_obrigatoria',
      'outras_rendas',
      'outras_rendas_obrigatoria',
      'origem_renda_secundaria',
      'origem_renda_secundaria_obrigatoria',
      'total_renda',
      // 'compor_renda'
    ]
  },
  {
    id: 3,
    name: 'FCRAPIDA',
    fields: [
      'renda_principal',
      'renda_principal_obrigatoria',
      'origem_renda',
      'origem_renda_obrigatoria',
      'outras_rendas',
      'outras_rendas_obrigatoria',
      'origem_renda_secundaria',
      'origem_renda_secundaria_obrigatoria',
      'total_renda',
      // 'compor_renda'
    ]
  },
  {
    id: 7,
    name: 'FCCOMPLETA',
    fields: [
      'renda_principal',
      'renda_principal_obrigatoria',
      'origem_renda',
      'origem_renda_obrigatoria',
      'outras_rendas',
      'outras_rendas_obrigatoria',
      'origem_renda_secundaria',
      'origem_renda_secundaria_obrigatoria',
      'total_renda',
      // 'compor_renda'
    ]
  },
  {
    id: 9,
    name: 'FCRAPIDA',
    fields: [
      'renda_principal',
      'renda_principal_obrigatoria',
      'origem_renda',
      'origem_renda_obrigatoria',
      'outras_rendas',
      'outras_rendas_obrigatoria',
      'origem_renda_secundaria',
      'origem_renda_secundaria_obrigatoria',
      'total_renda',
      // 'compor_renda'
    ]
  },
  {
    id: 10,
    name: 'FCRAPIDA',
    fields: [
      'renda_principal',
      'renda_principal_obrigatoria',
      'origem_renda',
      'origem_renda_obrigatoria',
      'outras_rendas',
      'outras_rendas_obrigatoria',
      'origem_renda_secundaria',
      'origem_renda_secundaria_obrigatoria',
      'total_renda',
      // 'compor_renda'
    ]
  },
  {
    id: 13,
    name: 'LUCIA_SOLICITA',
    fields: [
      'renda_principal',
      'renda_principal_obrigatoria',
      'origem_renda',
      'origem_renda_obrigatoria',
      'outras_rendas',
      'outras_rendas_obrigatoria',
      'origem_renda_secundaria',
      'origem_renda_secundaria_obrigatoria',
      'total_renda',
    ]
  },
  {
    id: 14,
    name: 'LUCIA_COLETA',
    fields: [
      'renda_principal',
      'renda_principal_obrigatoria',
      'origem_renda',
      'origem_renda_obrigatoria',
      'outras_rendas',
      'outras_rendas_obrigatoria',
      'origem_renda_secundaria',
      'origem_renda_secundaria_obrigatoria',
      'total_renda',
    ]
  },
];

const productsPJ = [
  {
    id: 1,
    name: 'FCRAPIDA',
    fields: [
      // 'faturamento_mensal',
      // 'tipo_negocio',
      // 'natureza_juridica'
      'receita_media_mensal',
      'capital_de_investimento',
      'patrimonio_estimado'
    ]
  },
  {
    id: 8,
    name: 'FCCOMPLETA',
    fields: [
      // 'faturamento_mensal',
      // 'tipo_negocio',
      // 'natureza_juridica'
      'receita_media_mensal',
      'capital_de_investimento',
      'patrimonio_estimado'
    ]
  },
  {
    id: 15,
    name: 'LUCIA_SOLICITA_PJ',
    fields: [
      'receita_media_mensal',
      'capital_de_investimento',
      'patrimonio_estimado'
    ]
  },
  {
    id: 16,
    name: 'LUCIA_COLETA_PJ',
    fields: [
      'receita_media_mensal',
      'capital_de_investimento',
      'patrimonio_estimado'
    ]
  }
];

export default (productsSent = [1], entity = 'PF', changedValues) => {
  if (entity === 'PF' || entity === "PJ") {
    const fieldsByProducts = productsSent.reduce((acc, id) => {
      if (entity === "PF") {
        const productsIndex = productsPF.findIndex(prd => prd.id === id);

        if (productsIndex !== -1) {
          return [...acc, ...productsPF[productsIndex].fields];
        }
      } else if (entity === "PJ") {
        const productsIndex = productsPJ.findIndex(prd => prd.id === id);

        if (productsIndex !== -1) {
          return [...acc, ...productsPJ[productsIndex].fields];
        }
      }

      return acc;
    }, []);

    let fieldsMerged = uniq(fieldsByProducts);

    // FC RAPIDA
    if (productsSent.indexOf(1) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // FC ESSENCIAL
    if (productsSent.indexOf(3) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // FC COMPLETA
    if (productsSent.indexOf(7) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // FC SCORE
    if (productsSent.indexOf(9) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // FC SCORE+
    if (productsSent.indexOf(10) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // LucIA SOLICITA
    if (productsSent.indexOf(13) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // LucIA COLETA
    if (productsSent.indexOf(14) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // LucIA SOLICITA PJ
    if (productsSent.indexOf(15) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    // LucIA COLETA PJ
    if (productsSent.indexOf(16) >= 0) {
      const fieldsToRemove = fcRapidaRules(entity, changedValues);
      fieldsMerged = fieldsMerged.filter((field) => fieldsToRemove.indexOf(field) < 0);
    }

    if (entity === "PF") {
      return incomeFieldsPF(changedValues).filter((field) => fieldsMerged.indexOf(field) >= 0);
    } else if (entity === "PJ") {
      return incomeFieldsPJ.filter((field) => fieldsMerged.indexOf(field) >= 0);
    }
  }
  
  return [];
}
